import moment from 'moment-timezone'

import { TIMEZONE, LOCALE } from '@src/globals'

export function formatDate (format, date = Date.now()) {
  return format
    ? moment.tz(date, TIMEZONE).locale(LOCALE).format(format)
    : date.toISOString()
}

export function formatLongDate (date = Date.now()) {
  const format = 'D [de] MMMM [de] YYYY'
  return formatDate(format, date)
}

export function format24hTime (time) {
  if (!time) {
    return time
  }

  const [ hour, minute ] = time.split(':')
  const parsedHour = parseInt(hour, 10)
  const amPm = parsedHour < 12 ? 'AM' : 'PM'
  const stringHour = '' + (parsedHour > 12 ? (parsedHour - 12) : parsedHour)
  const formattedTime = `${stringHour.replace(/^0/, '')}:${minute} ${amPm}`

  return formattedTime
}

export function pluralizedWeekday (date = Date.now()) {
  const weekday = formatDate('dddd', date)
  return weekday.slice(-1) === 's'
    ? weekday
    : weekday + 's'
}



// WEBPACK FOOTER //
// ./src/screens/App/shared/utils/dates.js